export const Servicios = {
  Admon: 4,
  Predial: 5,
  Valorizacion: 6,
};

export const TipoServicios = {
  ServicioPublicos: "9",
  Admon: "2",
  Impuestos: "3",
};

export const TipoCliente = {
  AseguradoraEntidadFinanciera: 2,
  Admon: 12,
  EpsServiciosPublicos: 13,
};
